<div class="primary-header">
    <ng-content select="[primaryHeader]"></ng-content>
</div>

<div #stickyContent class="sticky-content">
    <div class="secondary-header">
        <ng-content select="[secondaryHeader]"></ng-content>
    </div>
    <div class="centered-content">
        <div class="right-content">
            <ng-content select="[rightPageContent]"></ng-content>
        </div>
    </div>
</div>

<div #notStickyContent class="page-content">
    <ng-content select="[fullPageContent]"></ng-content>
    <div class="left-content">
        <ng-content select="[leftPageContent]"></ng-content>
    </div>
</div>
